export const isUrl = (candidate) => {
  var r = /^(ftp|http|https):\/\/[^ "]+$/;
  return r.test(candidate);
};
